import * as React from "react";

const SvgComponent = ({
  size = 36,    
  fill = "red"     ,// اندازه مطلوب برای هر دو محور (width و height)
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    width={size}
    height={size}
    fill={fill}
    {...props}
  
  >
    <circle cx={11} cy={11} r={10.5} fill="#fff" />
    <circle cx={11} cy={11} r={10.5} stroke="#fff" />
    <circle cx={11} cy={11} r={10.5} stroke="gray" strokeOpacity={0.2} />
    <path
      fill="#484848"
      fillRule="evenodd"
      d="M11 10.999c0 .17-.065.341-.195.471l-3.333 3.334a.667.667 0 1 1-.943-.943L9.391 11 6.529 8.136a.667.667 0 0 1 .943-.942l3.333 3.333c.13.13.195.301.195.472Z"
      clipRule="evenodd"
    />
    <path
      fill="#484848"
      fillRule="evenodd"
      d="M15.666 10.999c0 .17-.065.341-.195.471l-3.333 3.334a.667.667 0 1 1-.943-.943L14.057 11l-2.862-2.863a.667.667 0 0 1 .943-.942l3.333 3.333c.13.13.195.301.195.472Z"
      clipRule="evenodd"
      opacity={0.4}
    />
  </svg>
);

export default SvgComponent;
